import React, { useRef, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { ThemeContext } from '../contexts/ThemeContext';
import { PsychometricContext } from '../contexts/PsychometricContext';
import { useLocation, useHistory, useParams } from 'react-router-dom';

const IframeWrapper = ({ children, ...props }) => {
  const iframeRef = useRef(null);
  const themeContext = useContext(ThemeContext);
  const psychometricContext = useContext(PsychometricContext);
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    const iframe = iframeRef.current;
    const iframeDocument = iframe.contentDocument;
    const iframeWindow = iframe.contentWindow;

    // Add Bootstrap CSS
    const bootstrapLink = iframeDocument.createElement('link');
    bootstrapLink.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css';
    bootstrapLink.rel = 'stylesheet';
    iframeDocument.head.appendChild(bootstrapLink);

    // Inject styles into the iframe
    const style = iframeDocument.createElement('style');
    style.textContent = `
      body {
        font-family: ${themeContext.fontFamily.primary};
        color: ${themeContext.colors.text};
      }
      .progress {
        height: 10px;
        margin-bottom: 10px;
      }
      .progress-bar {
        background: linear-gradient(to right, #28a745 20%, transparent 20%);
      }
      h1, h2 {
        text-align: center;
        font-size: 1.5rem;
        font-weight: ${themeContext.fontWeight.bold};
        color: ${themeContext.colors.primaryGreenDark};
      }
      .likert-options {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 10px;
      }
      .likert-options label {
        margin: 5px 0;
        display: flex;
        align-items: center;
      }
      .likert-options label span {
        margin-left: 5px;
        font-weight: normal;
      }
      .btn {
        ${themeContext.newButtonRounded}
      }
      .btn-primary {
        ${themeContext.formSubmit}
      }
      .row {
        margin-right: -15px;
        margin-left: -15px;
      }
      .col-md-12 {
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
      }
      .d-flex {
        display: flex !important;
      }
      .justify-content-between {
        justify-content: space-between !important;
      }
      .mt-4 {
        margin-top: 1.5rem !important;
      }
      .mb-4 {
        margin-bottom: 1.5rem !important;
      }
      .p-3 {
        padding: 1rem !important;
      }
      .px-5 {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
      }
  .psychometricTestFooter {
        background-color: ${themeContext.theme.psychometricTestFooter.backgroundColor};
        color: ${themeContext.theme.psychometricTestFooter.color};
        padding: ${themeContext.theme.psychometricTestFooter.padding};
        text-align: ${themeContext.theme.psychometricTestFooter.textAlign};
        font-size: ${themeContext.theme.psychometricTestFooter.fontSize};
        font-family: ${themeContext.theme.psychometricTestFooter.fontFamily};
        font-weight: ${themeContext.theme.psychometricTestFooter.fontWeight};
  }
    `;
    iframeDocument.head.appendChild(style);

    // Create a div to render React components into
    const container = iframeDocument.createElement('div');
    iframeDocument.body.appendChild(container);

    // Render the children into the iframe, wrapped with ThemeContext and PsychometricContext
    ReactDOM.render(
      <ThemeContext.Provider value={themeContext}>
        <PsychometricContext.Provider value={psychometricContext}>
          {React.Children.map(children, child =>
            React.cloneElement(child, { location, history, params })
          )}
        </PsychometricContext.Provider>
      </ThemeContext.Provider>,
      container
    );

    // Clean up on unmount
    return () => {
      ReactDOM.unmountComponentAtNode(container);
    };
  }, [children, themeContext, psychometricContext, location, history, params]);

  return (
    <iframe
      ref={iframeRef}
      title="Embedded Content"
      style={{
        height: '100vh',
        width: '100%',
        border: 'none',
        overflow: 'hidden'
      }}
      {...props}
    />
  );
};

export default IframeWrapper;
